import React, { useEffect, useMemo, useState } from 'react'
import { Tonality } from '@dsny/dsny-component-library'
import { StyledComboboxInput } from './SelectInput.styles'

const SelectInput = ({
  value,
  label,
  selectOptions = [],
  onChangeValue,
  required,
  disabled,
  error,
  dataCy,
  placeholder,
  popoverStyle = { height: 130, maxHeight: 130, minHeight: 'unset' }
}) => {
  const selectedOption = useMemo(() => {
    return (
      selectOptions.find((opt) => opt.value === value) || {
        label: '',
        value: ''
      }
    )
  }, [value, selectOptions])

  const [open, setOpen] = useState(false)

  const openCombobox = () => {
    setOpen(true)
  }

  const closeCombobox = () => {
    setOpen(false)
  }

  const VERSION_TYPES_ARRAY = useMemo(() => selectOptions, [selectOptions])

  const onChange = (optionValue) => {
    onChangeValue(optionValue)
  }

  return (
    <div
      data-cy={dataCy}
      style={{
        display: 'flex',
        flex: '1'
      }}
    >
      <Tonality.Combobox
        isOpen={open}
        onClick={openCombobox}
        onClose={closeCombobox}
        onChange={onChange}
        value={selectedOption.label}
        label={label}
        style={{ flex: '1', height: '44px' }}
        disabled={disabled}
        setting="player"
        autoFocus={false}
      >
        <StyledComboboxInput
          disabled={disabled}
          required={required}
          hasError={error}
          inputLabelStyles={{ color: disabled && 'lightgrey' }}
          placeholder={placeholder}
        />

        <Tonality.ComboboxPopover style={{ ...popoverStyle }}>
          <Tonality.ComboboxList style={{ maxHeight: 130 }}>
            {VERSION_TYPES_ARRAY.map((option) => (
              <Tonality.ComboboxOption
                key={option.value}
                isSelected={option.value === selectedOption.value}
                value={option.value}
              >
                {option.label}
              </Tonality.ComboboxOption>
            ))}
          </Tonality.ComboboxList>
        </Tonality.ComboboxPopover>
      </Tonality.Combobox>
    </div>
  )
}

export default SelectInput
